import React from 'react';
import Header from '../components/Header';

const سياسةالخصوصية = () => {
  return (
    <div style={{ 
      width: '100%', 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: '#2B2F3F',
      overflow: 'hidden',
      direction: 'rtl'
    }}>
      <Header />
      <div style={{ 
        flex: 1, 
        padding: '32px', 
        backgroundColor: '#2B2F3F', 
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        boxSizing: 'border-box'
      }}>
        <h1 style={{
          fontFamily: 'El Messiri, sans-serif',
          fontSize: '24px',
          fontWeight: 700,
          color: '#FFFFFF',
          margin: '0 0 8px 0',
          textAlign: 'right'
        }}>
          سياسة الخصوصية
        </h1>

        <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          padding: '40px',
          border: '1px solid rgba(233, 106, 58, 0.15)',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)',
          boxSizing: 'border-box'
        }}>
          <div style={{
            fontFamily: 'Cairo, sans-serif',
            fontSize: '14px',
            lineHeight: '1.8',
            color: '#2B2F3F',
            textAlign: 'right'
          }}>
            <p style={{ marginBottom: '24px', color: '#666A7A' }}>
              آخر تحديث: {new Date().toLocaleDateString('ar-SA')}
            </p>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                1. جمع المعلومات
              </h2>
              <p style={{ marginBottom: '12px' }}>
                نقوم بجمع المعلومات التي تقدمها لنا مباشرة عند استخدامك للتطبيق، بما في ذلك:
              </p>
              <ul style={{ paddingRight: '20px', marginBottom: '12px' }}>
                <li>معلومات الحساب (الاسم، البريد الإلكتروني، رقم الهاتف)</li>
                <li>معلومات الطلبات والعمليات</li>
                <li>معلومات الموقع (إذا سمحت بذلك)</li>
                <li>معلومات الجهاز (نوع الجهاز، نظام التشغيل)</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                2. استخدام المعلومات
              </h2>
              <p style={{ marginBottom: '12px' }}>
                نستخدم المعلومات التي نجمعها لـ:
              </p>
              <ul style={{ paddingRight: '20px', marginBottom: '12px' }}>
                <li>تقديم وتحسين خدماتنا</li>
                <li>معالجة الطلبات والدفعات</li>
                <li>التواصل معك بشأن طلباتك</li>
                <li>إرسال الإشعارات والتحديثات</li>
                <li>تحسين تجربة المستخدم</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                3. مشاركة المعلومات
              </h2>
              <p style={{ marginBottom: '12px' }}>
                نحن لا نبيع معلوماتك الشخصية. قد نشارك معلوماتك مع:
              </p>
              <ul style={{ paddingRight: '20px', marginBottom: '12px' }}>
                <li>مقدمي الخدمات الذين يساعدوننا في تشغيل التطبيق</li>
                <li>السلطات القانونية عند الحاجة</li>
                <li>في حالة دمج أو بيع الشركة</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                4. أمان المعلومات
              </h2>
              <p style={{ marginBottom: '12px' }}>
                نحن نتخذ تدابير أمنية معقولة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو التغيير أو الكشف أو التدمير.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                5. حقوقك
              </h2>
              <p style={{ marginBottom: '12px' }}>
                لديك الحق في:
              </p>
              <ul style={{ paddingRight: '20px', marginBottom: '12px' }}>
                <li>الوصول إلى معلوماتك الشخصية</li>
                <li>تصحيح معلوماتك الشخصية</li>
                <li>حذف معلوماتك الشخصية</li>
                <li>الاعتراض على معالجة معلوماتك</li>
              </ul>
            </section>

            <section>
              <h2 style={{
                fontFamily: 'El Messiri, sans-serif',
                fontSize: '18px',
                fontWeight: 700,
                color: '#E96A3A',
                marginBottom: '16px'
              }}>
                6. الاتصال بنا
              </h2>
              <p style={{ marginBottom: '12px' }}>
                إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال بنا عبر:
              </p>
              <ul style={{ paddingRight: '20px' }}>
                <li>البريد الإلكتروني: privacy@minbayty.com</li>
                <li>الهاتف: +966 50 123 4567</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default سياسةالخصوصية;




